import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function LockUp() {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  const la = localStorage.getItem("i18n") ? localStorage.getItem("i18n") : "en";
  return (
    <div className="container mx-auto  md:rounded-[30px] overflow-hidden">
      <img
        src={
          la == "zh"
            ? "/level/20220324030143175182.png"
            : "/level/2022032403014737859.png"
        }
        className="object-contain max-w-400px mx-auto md:rounded-[30px]"
        onClick={() => {
          navigate("/lockUpCenter");
        }}
      />
    </div>
  );
}
